export default __webpack_public_path__ + "static/banner-renovation-diy-a2ceb95e7e6f0d5e9d69aa115353d45f.jpg";